import { Component } from '@angular/core';
import { IonicPage, NavController, MenuController } from 'ionic-angular';

import { LoginPage } from '../login/login';

@IonicPage()
@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html'
})
export class WelcomePage {

  constructor(public navCtrl: NavController,private menu: MenuController) {}


  // openFirst() {
  //   this.menu.enable(true, 'first');
  //   this.menu.open('first');
  // }

  login(param){
    this.navCtrl.push(LoginPage,{item:param});
  }
}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts